var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Ad2',_vm._b({attrs:{"style-type":8}},'Ad2',_vm.$props,false))
}
var staticRenderFns = []

export { render, staticRenderFns }